module.exports = __webpack_public_path__ + "static/img_0373-fc95df7a742b735d8ed6f4a5e53c44d1.webp";